window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};
$(document).ready(function(){
    $('.customer-logos').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 3
            }
        }]
    });
});

var selectCallback = function(variant, selector){
    if(variant && variant.available){
        $('.hidden').removeClass('disabled').removeAttr('disabled');
        // Enable the Add to Cart button
        $('.options .price').html('<strong>'+Shopify.formatMoney(variant.price, "{{shop.money_with_currency_format}}")+'</strong>');
        // Show price of the currently selected variant
    }
    else{
        $('#add-to-cart').addClass('disabled').attr('disabled', 'disabled');
        // Disable the Add to Cart button
        $('.options .price').text("Sold Out!");
        // Swap price with a 'Sold Out' message
    }
};

$(theme.init);
// $(document).ready(function(){
   //  $('body').on('click', '.CustAddToCart', function(){
    // var abc=$(this).prev(".ProductTitle").text();
    //  $("#producttitle0").val(abc);
     // var abc=$(this).parent(".prot").children(".ImgArea").attr("src");
     // $("#product-url1").val(abc);
    //  console.log(abc);
   // });
     
 
  //});

//  $(document).ready(function(){
//      $('body').on('click', '.CustAddToCart', function(){
//      var abc1=$(this).prev(".ProductTitle").text();
//       var abc=$(this).parent(".prot").children(".ImgArea").attr("src");
//       $(".line-item-property__field").each(function(){
//        if ($(this).hasClass("active")){
//        }else{
//       $(this).val(abc,abc1);
//         $(this).addClass("title");
       
//          console.log(abc); 
//           return false;
//       }
//     });
//    });
//  });
$(document).ready(function(){
//alert("testing");
  $(".CustAddToCart").click(function(){
  var src = $(this).parents(".prot").children(".ImgArea").attr("src");
    var title=$(this).prev(".ProductTitle").text();
    //alert(src);
    $(".line-item-property__field").each(function(){
    if($(this).hasClass("active"))
    {
   
    }
      else{
     $(this).children(".title").attr("value",title);
       $(this).children(".image").attr("value",src);
        $(this).addClass("active");
        return false;
      }
    });
  });
});
 




   